import * as types from '../const/action.types';
//import { keepSession } from './session.actions';
import api from '../api/ManageProcessApi';
import { get, put, del, post } from '../api/_basic';
import randomstring from 'uuid/v4';

export function manageProcessHasErrored(bool, message) {
    return {
        type: types.MANAGE_PROCESS_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function manageProcessIsLoading(bool) {
    return {
        type: types.MANAGE_PROCESS_IS_LOADING,
        isLoading: bool,
    };
}

export function manageProcessFetchDataSuccess(items) {
    return {
        type: types.MANAGE_PROCESS_FETCH_DATA,
        items,
    };
}

export function loadManageProcesses() {
    console.log('loadManageProcesses');
    return async (dispatch) => {
        dispatch(manageProcessIsLoading(true));
        dispatch(manageProcessHasErrored(false, ''));
        try {
            const response = await api.get();
            if (response.error !== undefined) {
                throw Error(response);
            }
            const items = response;
            dispatch(manageProcessIsLoading(false));
            dispatch(manageProcessHasErrored(false, ''));
            dispatch(manageProcessFetchDataSuccess(items));
        } catch (error) {
            dispatch(manageProcessIsLoading(false));
            dispatch(manageProcessHasErrored(error.type ? error.type : true, error.message));
        }
    };
}

export function loadManageProcess(code) {
    return async (dispatch) => {
        dispatch(manageProcessIsLoading(true));
        dispatch(manageProcessHasErrored(false, ''));
        try {
            const response = await get(process.env.REACT_APP_API_MANAGE_NPROCESS + '/' + code);

            dispatch(manageProcessIsLoading(false));
            dispatch(manageProcessHasErrored(false, ''));

            if (response.error !== undefined) {
                throw Error(response);
            }

            return response;
        } catch (error) {
            dispatch(manageProcessIsLoading(false));
            throw Error(error);
        }
    };
}

export function loadTemplateProcess(proceso) {
    return async (dispatch) => {
        return get(process.env.REACT_APP_API_MANAGE_PROCESS + '/' + proceso + '/plantilla')
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function renameFamily(oldcode, oldname, name, code) {
    return async (dispatch) => {
        dispatch(manageProcessIsLoading(true));
        try {
            const response = await put(
                process.env.REACT_APP_API_FAMILY_PROCESS + '/' + oldname + '/' + name,
                {},
            );
            dispatch(manageProcessIsLoading(false));
            dispatch(manageProcessEditFamily(oldcode, name, code));
            if (response.error !== undefined) {
                throw Error(response);
            }
            return response;
        } catch (error) {
            dispatch(manageProcessIsLoading(false));
            throw Error(error);
        }
    };
}

export function manageProcessAddFamily(name, code) {
    return {
        type: types.MANAGE_PROCESS_ADD_FAMILY,
        name,
        code,
    };
}

export function manageProcessEditFamily(old, name, code) {
    return {
        type: types.MANAGE_PROCESS_EDIT_FAMILY,
        old,
        name,
        code,
    };
}

export function manageProcessDuplicateFamily(name, code) {
    return {
        type: types.MANAGE_PROCESS_DUPLICATE_FAMILY,
        name,
        code,
    };
}

export function manageProcessDeleteFamily(name, code) {
    return {
        type: types.MANAGE_PROCESS_DELETE_FAMILY,
        name,
        code,
    };
}

export function addProcess(data, family) {
    return async (dispatch) => {
        dispatch(manageProcessIsSaving(true));
        dispatch(manageProcessHasErrored(false, ''));
        return post(process.env.REACT_APP_API_MANAGE_NPROCESS, data)
            .then((response) => {
                dispatch(manageProcessIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                if (items && items.codigo) {
                    data.codigo = items.codigo;
                }
                dispatch(manageProcessHasErrored(false, ''));
                dispatch(manageProcessAddProcess(data, family));
                dispatch(loadManageProcesses());
            })
            .catch((error) => {
                dispatch(manageProcessHasErrored(error.type ? error.type : true, error.message));
                throw error;
            });
    };
}

export function launch(processCode, local, employee) {
    return async (dispatch) => {
        return api
            .launch(processCode, local, employee)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.error);
                }
                return response;
            })
            .catch((error) => {
                throw Error(error.message);
            });
    };
}

export function duplicateProcess(
    data,
    name,
    idCliente,
    rules,
    programming,
    programmingfields,
    clonarpermisos,
    duplicated,
) {
    return async (dispatch) => {
        dispatch(manageProcessIsSaving(true));
        dispatch(manageProcessHasErrored(false, ''));
        const aux = JSON.parse(JSON.stringify(data));
        aux.nombre = name;
        aux.codigo = randomstring();
        if (idCliente) {
            aux.cliente = idCliente;
        }

        return api
            .duplicate(
                data.codigo,
                aux.nombre,
                aux.codigo,
                idCliente,
                rules,
                programming,
                programmingfields,
                clonarpermisos,
            )
            .then((response) => {
                dispatch(manageProcessIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                dispatch(manageProcessHasErrored(false, ''));
                dispatch(loadManageProcesses());
                return !duplicated;
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function editProcess(old, data, family) {
    return async (dispatch) => {
        dispatch(manageProcessIsSaving(true));
        dispatch(manageProcessHasErrored(false, ''));
        return put(process.env.REACT_APP_API_MANAGE_NPROCESS + '/' + old, data)
            .then((response) => {
                dispatch(manageProcessIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(manageProcessHasErrored(false, ''));
                dispatch(manageProcessEditProcess(old, data, family));
                dispatch(loadManageProcesses());
            })
            .catch((error) => {
                console.error(error);
                dispatch(manageProcessHasErrored(error.type ? error.type : true, error.message));
                throw error;
            });
    };
}

export function deleteProcess(name, code, family) {
    return async (dispatch) => {
        dispatch(manageProcessIsSaving(true));
        dispatch(manageProcessHasErrored(false, ''));
        return del(process.env.REACT_APP_API_MANAGE_PROCESS + '/' + code)
            .then((response) => {
                //dispatch(keepSession());
                dispatch(manageProcessIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(manageProcessHasErrored(false, ''));
                dispatch(manageProcessDeleteProcess(name, code, family));
            })
            .catch((error) => {
                dispatch(manageProcessHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function manageProcessIsSaving(bool) {
    return {
        type: types.MANAGE_PROCESS_IS_SAVING,
        isSaving: bool,
    };
}

export function manageProcessAddProcess(data, family) {
    return {
        type: types.MANAGE_PROCESS_ADD_PROCESS,
        data,
        family,
    };
}

export function manageProcessEditProcess(old, data, family) {
    console.log(old, data, family);
    return {
        type: types.MANAGE_PROCESS_EDIT_PROCESS,
        old,
        data,
        family,
    };
}

export function manageProcessDuplicateProcess(data, family) {
    return {
        type: types.MANAGE_PROCESS_DUPLICATE_PROCESS,
        data,
        family,
    };
}

export function manageProcessDeleteProcess(name, code, family) {
    return {
        type: types.MANAGE_PROCESS_DELETE_PROCESS,
        name,
        code,
        family,
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.manage.process.actions.js